import { Autocomplete, Button, Dialog, DialogContent, DialogTitle, Grid, List, ListItemButton, TextField, Tooltip, Typography } from '@mui/material';
import {useState, useEffect} from 'react';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./EmailTab.css";
import _ from "lodash"
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box} from '@mui/material';
import {createDNSData, getSendGridTableData, verifyDNSData, sendtestEmail, getSmtpEmailData, createSmtpEmailData, getMicrosoftGraphEmailData, createMicrosoftGraphEmailData, smtptestEmail, msGraphtestEmail, smtpDataDelete, msgraphDataDelete, sendGridDataDelete} from "../../actions/Users/authenticateGroupSettings";
import LabelValueDisplay from '../../UserScreen/InventoryPage/InventorySettings/components/LabelValue/LabelValueDisplay';
import NetworkTable, { ColumnConfig, ColumnType, NetworkTableRow } from '../../UserScreen/InventoryPage/InventorySettings/components/InterfacesTable/NetworkTable/NetworkTable';
import SectionTitleWithHr from "../../UserScreen/InventoryPage/InventorySettings/components/SectionTitleWithHR/SectionTitleWithHr";
import valid from "../../asset/image/valid.svg";
import invalid from "../../asset/image/invalid.svg";
import copy_icon from "../../asset/image/copy_icon.svg";
import close from "../../asset/image/close.svg";
import AddButton from "../../UserScreen/InventoryPage/InventorySettings/components/AddButton/AddButton";
import email_success from "../../asset/image/email_success.svg";
import email_fail from "../../asset/image/email_fail.svg";
import delete_icon from "../../asset/image/delete_icon.svg";
import TestmailDialog from "./TestmailDialog";
import SendgridTestmailDialog from "./SendgridTestmailDialog";
import SmtpTestmailDialog from "./SmtpTestmailDialog";
import MsgraphTestmailDialog from "./MsgraphTestmailDialog";
import CustomLoader from "../Loader/CustomLoaders";
import DeleteWANProfileModal from "../../UserScreen/InventoryPage/InventorySettings/components/Modals/DeleteProfileModal";

type DnsRecord = {
  valid: boolean;
  type: string;
  host: string;
  data: string;
  reason: string;
};

type SmtpDataType = {
    hostValue: string;
    portvalue: number;
    password: string;
}
type MsgrpahDataType = {
    clientID: string;
    tenantID: string;
    clientSecrete: string;
}

const EmailTab = (props) => {
    const {selectedService, setSelectedService, dpId, testmailValid, setTestmailvalid, whitelabeled, authReducer, createDNSData, getSendGridTableData, verifyDNSData, sendtestEmail, getSmtpEmailData, createSmtpEmailData, getMicrosoftGraphEmailData, createMicrosoftGraphEmailData, smtptestEmail, msGraphtestEmail, smtpDataDelete, msgraphDataDelete, sendGridDataDelete,
        sendTestemail, getSmtpData, createDNS, verifyDNS, deleteSendgridData, getSendGridData, createSmtpData, deletesmtpData, getMicrosoftEmailData, smtpTestemail, msGraphTestemail, createMicrosoftGraphData, deleteMsgraphData, sendGridDataLoading, loading
    } = props

    const [smtpData, setSmtpData] = useState<SmtpDataType>({
        hostValue: "",
        portvalue: 0,
        password: "",
    });
    const [msgrapgData, setMsgraphData] = useState<MsgrpahDataType>({
        clientID: "",
        tenantID: "",
        clientSecrete: ""
    });
    const [email, setEmail] = useState("");
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [data, setData] = useState<any[]>([]);
    const [domainId, setDomainId] = useState("");
    const [testmailOpen, setTestmailOpen] = useState(false);
    const [recMail, setRecMail] = useState("");
    const [recMailValid, setRecMailValid] = useState(false);
    const [successFail, setsuccessFail] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    const [copiedKey, setCopiedKey] = useState<string | null>(null);
    const [deleteEmailOpen, setDeleteEmailOpen] = useState(false);

    const handleCopy = (value: string, key: string) => {
    navigator.clipboard.writeText(value);
    setCopiedKey(key);
    setTimeout(() => setCopiedKey(null), 1500);
    };

    const handleSmtpDetailsChange= (value: any, key: keyof SmtpDataType) => {
        setSmtpData((prev) => ({
            ...prev,
            [key]: value
        }))
    }

    const handleMsgraphDetailsChange = (e: any, key: keyof MsgrpahDataType) => {
        setMsgraphData((prev) => ({
            ...prev,
            [key]: e.target.value
        }))
    }

    const handleCreateDNS = () => {
        const payload = {
            "ouId": dpId,
            "senderEmailId": email
        }
        createDNSData(payload)
    }

    const handleVerifyDNS = () => {
        const payload = {
            "ouId":"DP-0001",
            "domainId":domainId
        }
        verifyDNSData(payload)
    }

    const handletestEmail = () => {
        setTestmailOpen(true);
    }

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        setIsEmailValid(validateEmail(value));
    }

    const handleRecEmailChange = (e) => {
        const value = e.target.value;
        setRecMail(value);
        setRecMailValid(validateEmail(value));
    }

    const handleEmailSend = () => {
        if(selectedService == "SendGrid"){
            const payload = {
                "receiverEmailId" : recMail
            }
            sendtestEmail(dpId, payload);
        }
        else if (selectedService == "SMTP"){
            const payload = {
                "receiverEmailId": recMail,
                "senderEmail": email,
                "password": smtpData.password,
                "host": smtpData.hostValue,
                "port": smtpData.portvalue
            }
            smtptestEmail(dpId, payload);
        }
        else if(selectedService == "Microsoft Graph API"){
            const payload = {
                "receiverEmailId": recMail,
                "clientId": msgrapgData.clientID,
                "tenantId": msgrapgData.tenantID,
                "clientSecret": msgrapgData.clientSecrete,
                "senderEmail": email
            }
            msGraphtestEmail(dpId, payload);
        }
        setTestmailOpen(false);
        setsuccessFail(true)
    }

    const handleCancelTestmail = () => {
        setRecMail("");
        setRecMailValid(false);
        setTestmailOpen(false)
    }

    const handleCancelSuccessFail = () => {
        setRecMail("");
        setRecMailValid(false);
        setsuccessFail(false);
    }

    const handleCreateSMTPData = () => {
        const payload = {
            "ouId": dpId,
            "senderEmail": email,
            "password": smtpData.password,
            "host": smtpData.hostValue,
            "port": smtpData.portvalue
        }
        createSmtpEmailData(payload);
    }

    const handleCreateMicrosoftGraphData = () => {
        const payload = {
            "ouId": dpId,
            "clientId": msgrapgData.clientID,
            "tenantId": msgrapgData.tenantID,
            "clientSecret": msgrapgData.clientSecrete,
            "senderEmail": email
        }
        createMicrosoftGraphEmailData(payload)
    }

    const onDeleteClick = () => {
        if(selectedService == "SMTP"){
            smtpDataDelete(dpId, selectedService);
        }
        else if(selectedService == "Microsoft Graph API"){
            msgraphDataDelete(dpId, selectedService);
        }
        else if(selectedService == "SendGrid"){
            sendGridDataDelete(dpId, selectedService);
        }
        setDeleteEmailOpen(false);
    }


    useEffect(()=> {
        if(selectedService == "SendGrid"){
            getSendGridTableData(dpId);
        }
        else if(selectedService == "SMTP"){
            getSmtpEmailData(dpId);
        }
        else if(selectedService == "Microsoft Graph API"){
            getMicrosoftGraphEmailData(dpId);
        }
    }, [selectedService])

    useEffect(() => {
        if(!_.isEmpty(createDNS) || !_.isEmpty(verifyDNS) || !_.isEmpty(deleteSendgridData)){
            if(createDNS?.success == true || verifyDNS?.success == true || deleteSendgridData?.success == true){
                getSendGridTableData(dpId);
            }
        }
    }, [createDNS, verifyDNS, deleteSendgridData])

    const validateEmail = (email: string) => {
        return /\S+@\S+\.\S+/.test(email);
    };

    const validEmail = (email) => {
        return true;
    }

    useEffect(() => {
        if(!_.isEmpty(getSendGridData)){
            setEmail(getSendGridData?.data?.senderEmailId);
            setIsEmailValid(getSendGridData?.data?.senderEmailId);
            setDomainId(getSendGridData?.data?.id);
            setTestmailvalid(selectedService == "SendGrid" && getSendGridData?.data?.valid);
            setDeleteOpen(selectedService == "SendGrid" && getSendGridData?.data);
            const dnsTableData = Object.entries(getSendGridData?.data?.dns || {}).map(([recordType, details]) => {
                const record = details as {
                    valid: boolean;
                    type: string;
                    host: string;
                    data: string;
                    reason: string;
                };
                return {
                    "Record Type": recordType ,
                    "Valid": record.valid ,
                    "Type": record.type ,
                    "Host": record.host ,
                    "Data": record.data ,
                    "Reason": record.reason
                };
            }
            );
            const table = getSendGridData?.data?.senderEmailId != "" ? dnsTableData : []
            setData(table);
        }

    },[getSendGridData])

    useEffect(() => {
        if(!_.isEmpty(createSmtpData) || !_.isEmpty(deletesmtpData)){
            if(createSmtpData?.success == true || deletesmtpData.success == true){
                getSmtpEmailData(dpId);
            }
        }
    }, [createSmtpData, deletesmtpData])

    useEffect(() => {
        if(!_.isEmpty(getSmtpData)){
            setEmail(getSmtpData?.data?.senderEmail);
            setIsEmailValid(getSmtpData?.data?.senderEmail);
            setSmtpData({
                password: getSmtpData?.data?.password || "",
                hostValue: getSmtpData?.data?.host || "",
                portvalue: getSmtpData?.data?.port ?? 0,
            });
            setTestmailvalid(selectedService == "SMTP" && getSmtpData?.data?.password && getSmtpData?.data?.host && getSmtpData?.data?.port)
            setDeleteOpen(selectedService == "SMTP" && getSmtpData?.data.password && getSmtpData?.data?.host && getSmtpData?.data?.port)
        }
    }, [getSmtpData])

    useEffect(() => {
        if(!_.isEmpty(createMicrosoftGraphData) || !_.isEmpty(deleteMsgraphData)){
            if(createMicrosoftGraphData?.success == true || deleteMsgraphData?.success == true){
                getMicrosoftGraphEmailData(dpId);
            }
        }
    }, [createMicrosoftGraphData, deleteMsgraphData])

    useEffect(() => {
        if(!_.isEmpty(getMicrosoftEmailData)){
            setEmail(getMicrosoftEmailData?.data?.senderEmail);
            setIsEmailValid(getMicrosoftEmailData?.data?.senderEmail);
            setMsgraphData({
                tenantID: getMicrosoftEmailData?.data?.tenantId,
                clientID: getMicrosoftEmailData?.data?.clientId,
                clientSecrete: getMicrosoftEmailData?.data?.clientSecret
            })
            setTestmailvalid(selectedService == "Microsoft Graph API" && getMicrosoftEmailData?.data?.clientSecret && getMicrosoftEmailData?.data?.clientId && getMicrosoftEmailData?.data?.tenantId)
            setDeleteOpen(selectedService == "Microsoft Graph API" && getMicrosoftEmailData?.data?.clientSecret && getMicrosoftEmailData?.data?.clientId && getMicrosoftEmailData?.data?.tenantId)
        }
    }, [getMicrosoftEmailData])

    return (
        <div className="emailTab">
            <div className="transfer-tab-grid authServiceDiv">
                <LabelValueDisplay
                    label="Sender Email"
                    isInput
                    value={email}
                    onChange={(e) => {handleEmailChange(e)}}
                    placeholder="Enter Email ID"
                    width = {531}
                />
                <Button className="TestEmailButton" onClick={handletestEmail} disabled={!testmailValid || !isEmailValid}>Test Email</Button>
                <img
                    title={"delete"}
                    src={delete_icon}
                    onClick={deleteOpen ? () => setDeleteEmailOpen(true) : undefined}
                    style={{
                        width: 24,
                        height: 24,
                        marginTop: "8px",
                        cursor: deleteOpen ? 'pointer' : 'not-allowed',
                        filter: deleteOpen ? 'none' : 'grayscale(100%) opacity(0.5)',
                    }}
                    alt="Delete"
                />
            </div>
            <DeleteWANProfileModal
                open={deleteEmailOpen}
                onClose={() => { setDeleteEmailOpen(false)}}
                onConfirm={onDeleteClick}
                title={"Delete"}
                confirmText={"Delete"}
                entityLabel={`Deleting the senders email records`}
                entityName={email}
                // errorMessage={"This action cannot be undone."}
            />
            <div className="transfer-tab-grid serviceOptions">
                <LabelValueDisplay
                    label="Sender Authentication Service"
                    isDropdown
                    value={selectedService}
                    dropdownOptions={["SMTP", "Microsoft Graph API", whitelabeled && "SendGrid"]}
                    onChange={(e) => {setSelectedService(e.target.value)}}
                    placeholder=""
                    width = {630}
                />
            </div>
            {selectedService == "SMTP" && <Grid>
                <Grid className="selectedService">
                    <LabelValueDisplay
                        label="Host"
                        isInput
                        value={smtpData.hostValue}
                        onChange={(e) => handleSmtpDetailsChange(e.target.value, "hostValue")}
                        placeholder="Enter Host"
                        width = {310}
                    />
                    <LabelValueDisplay
                        label="Port"
                        isInput
                        value={smtpData.portvalue}
                        onChange={(e) => handleSmtpDetailsChange(Number(e.target.value), "portvalue")}
                        placeholder="Enter Port"
                        width = {310}
                    />
                </Grid>
                <LabelValueDisplay
                    label="Password"
                    isInput
                    type="password"
                    value={smtpData.password}
                    onChange={(e) => handleSmtpDetailsChange(e.target.value, "password")}
                    placeholder="Enter Password"
                    width = {310}
                />
                <div className="dnsbuttonDiv">
                    <Button className="dnsButton" onClick={handleCreateSMTPData} disabled={smtpData.hostValue== "" || smtpData.portvalue == 0 || smtpData.password == "" || testmailValid}>Create</Button>
                </div>
            </Grid>}
            {selectedService == "Microsoft Graph API" && <Grid>
                <Grid className="selectedService">
                    <LabelValueDisplay
                        label="Tenant ID"
                        isInput
                        value={msgrapgData.tenantID}
                        onChange={(e) => handleMsgraphDetailsChange(e, "tenantID")}
                        placeholder="Enter Tenant ID"
                        width = {310}
                    />
                    <LabelValueDisplay
                        label="Client ID"
                        isInput
                        value={msgrapgData.clientID}
                        onChange={(e) => handleMsgraphDetailsChange(e, "clientID")}
                        placeholder="Enter Client ID"
                        width = {310}
                    />
                </Grid>
                <LabelValueDisplay
                    label="Client Secret"
                    isInput
                    type="password"
                    value={msgrapgData.clientSecrete}
                    onChange={(e) => handleMsgraphDetailsChange(e, "clientSecrete")}
                    placeholder="Enter Client Secret"
                    width = {310}
                />
                <div className="dnsbuttonDiv">
                    <Button className="dnsButton" onClick={handleCreateMicrosoftGraphData} disabled={msgrapgData.clientID== "" || msgrapgData.tenantID == "" || msgrapgData.clientSecrete == "" || testmailValid}>Create</Button>
                </div>
            </Grid>}
            {selectedService == "SendGrid" && <Grid>
                {(data.length > 0 && !testmailValid) && <SectionTitleWithHr title="you need to install the following records to complete the process" />}
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell className="sendgridCell">Status</TableCell>
                            <TableCell className="sendgridCell">Type</TableCell>
                            <TableCell className="sendgridCell">Host</TableCell>
                            <TableCell className="sendgridCell">Value</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        {data.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={4} style={{backgroundColor: "#f5f5f5"}}>
                                <Box display="flex" justifyContent="center" py={2}>
                                    {sendGridDataLoading == false &&<Button variant="contained" className="dnsButton" onClick={handleCreateDNS} disabled={!isEmailValid}>
                                        Click to Request DNS Values from Sendgrid
                                    </Button>}
                                    {sendGridDataLoading == true && <Button variant="contained" className="dnsButton"  disabled={true}>
                                        Getting values from Sendgrid
                                    </Button>}
                                </Box>
                              </TableCell>
                            </TableRow>
                        ) : (
                            data.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell className="sendgridData textAlign" title={row.Valid ? "valid" : "invalid"}>{row.Valid ? <img src={valid}></img> : <img src={invalid}></img>}</TableCell>
                                <TableCell className="sendgridData">{row.Type}</TableCell>
                                <TableCell className="sendgridData"><div className="displayFlex"><span>{row.Host}</span><img src={copy_icon} className="marginLeftAuto cursor" onClick={() => handleCopy(row.Host, `host-${index}`)}></img></div>{copiedKey === `host-${index}` && (
                                    <div className="copyPopup">Copied!</div>)}</TableCell>
                                <TableCell className="sendgridData"><div className="displayFlex"><span>{row.Data}</span><img src={copy_icon} className="marginLeftAuto cursor" onClick={() => handleCopy(row.Data, `data-${index}`)}></img></div>{copiedKey === `data-${index}` && (
                                    <div className="copyPopup">Copied!</div>)}</TableCell>
                            </TableRow>
                            ))
                        )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className="dnsbuttonDiv">
                    <AddButton onAddClick={handleVerifyDNS} disabled={data.length == 0 || testmailValid} addLabel={"Verify DNS Settings"} maxWidth={"150px"}/>
                    {/* <Button className="dnsButton" onClick={handleVerifyDNS} disabled={data.length == 0 || testmailValid}>Verify DNS Settings</Button> */}
                </div>
            </Grid>}
            <TestmailDialog testmailOpen={testmailOpen} handleCancelTestmail={handleCancelTestmail} handleEmailSend={handleEmailSend} email={email} recMail={recMail} handleRecEmailChange={handleRecEmailChange} recMailValid={recMailValid}/>
            <SendgridTestmailDialog sendTestemail={sendTestemail} successFail={successFail} handleCancelSuccessFail={handleCancelSuccessFail} email={email} recMail={recMail}/>
            <SmtpTestmailDialog smtpTestemail={smtpTestemail} successFail={successFail} email={email} recMail={recMail} handleCancelSuccessFail={handleCancelSuccessFail}/>
            <MsgraphTestmailDialog msGraphTestemail={msGraphTestemail} successFail={successFail} email={email} recMail={recMail} handleCancelSuccessFail={handleCancelSuccessFail}/>
        </div>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    sendTestemail: state.authReducer?.sendTestemail,
    getSmtpData: state.authReducer?.getSmtpData,
    createDNS: state.authReducer?.createDNS,
    verifyDNS: state.authReducer?.verifyDNS,
    deleteSendgridData: state.authReducer?.deleteSendgridData,
    getSendGridData: state.authReducer?.getSendGridData,
    createSmtpData: state.authReducer?.createSmtpData,
    deletesmtpData: state.authReducer?.deletesmtpData,
    getMicrosoftEmailData: state.authReducer?.getMicrosoftEmailData,
    smtpTestemail: state.authReducer?.smtpTestemail,
    msGraphTestemail: state.authReducer?.msGraphTestemail,
    createMicrosoftGraphData: state.authReducer?.createMicrosoftGraphData,
    deleteMsgraphData: state.authReducer?.deleteMsgraphData,
    sendGridDataLoading: state.authReducer?.sendGridDataLoading,
    loading: state.authReducer?.setLoading
});

export default withRouter(
    connect(mapStateToProps, {
        createDNSData, getSendGridTableData, verifyDNSData, sendtestEmail, getSmtpEmailData, createSmtpEmailData, getMicrosoftGraphEmailData, createMicrosoftGraphEmailData, smtptestEmail, msGraphtestEmail, smtpDataDelete, msgraphDataDelete, sendGridDataDelete
    })(EmailTab)
)
